import React, { Component, useState, useEffect, useRef, useLayoutEffect } from 'react'

import { AnimatePresence, motion, useMotionValue, useTransform, animate, useScroll, useMotionValueEvent, useAnimationControls, motionValue } from "framer-motion"

import { NavLink, Link } from "react-router-dom"

import Modal from 'react-modal';

import Sidebar from '../elements/Sidebar.jsx'
import Controller from '../elements/Controller.jsx'
import MetricHeader from '../elements/MetricHeader.jsx'
import MainLayout from '../elements/MainLayout.jsx'
import ModalManager from '../elements/ModalManager.jsx'

import ReceiveDollar from '../media/icons/icons8-receive-dollar-96.png'
import RequestMoney from '../media/icons/icons8-request-money-96.png'
import Contract from '../media/icons/icons8-contract-96.png'
import Save from '../media/icons/icons8-save-96.png'
import Delete from '../media/icons/icons8-delete-96.png'

import Button from '../elements/Button.jsx'
import Counter from '../elements/Counter.jsx'
import TextInput from '../elements/TextInput.jsx'
import Table from '../elements/Table.jsx'
import IconButton from '../elements/IconButton.jsx'
import Dropdown from '../elements/ReactSelectDropdown.jsx'

import ManageTemplate from '../assets/thursdayreporting/ManageTemplates.jsx'
import SaveTemplate from '../assets/thursdayreporting/SaveTemplate.jsx'
import SubmitReport from '../assets/commissionreceivedos/SubmitReport.jsx'
import DenyReport from '../assets/DenyConfirm.jsx'

import Approve from '../media/icons/icons8-approve-96.png'
import Deny from '../media/icons/icons8-cancel-96.png'

import Notification from '../elements/Notification.jsx'

import { useCookies } from 'react-cookie'

const Main = (props) => {

    const [refresh, setRefresh] = useState(false)

    const refreshData = () => {
        setRefresh((refresh) => !refresh)
    }

    const buttonList = [
        {
            name: 'Home',
            link: '/',
            onClick: () => {},
        },
        // {
        //     name: 'Show Table Data',
        //     link: '',
        //     onClick: () => {showTableData()},
        // },
    ]

    const headerData = [
        {
            image: ReceiveDollar,
            title: 'Weekly Gross',
            change: 7,
            total: 21750,
        },
        {
            image: RequestMoney,
            title: 'Weekly Net',
            change: 5,
            total: 12275,
        },
        {
            image: Contract,
            title: 'Weekly Contracts',
            change: 12,
            total: 24.5,
        },
        {
            image: Contract,
            title: 'Monthly Contracts',
            change: -3,
            total: 123,
        },
    ]

    const dealers2 = [
        { value: '4 Season Motors', label: '4 Season Motors' },
        { value: 'Chopper City', label: 'Chopper City' },
        { value: 'Auto Station', label: 'Auto Station' },
        { value: 'Duke City Auto LLC', label: 'Duke City Auto LLC' },
        { value: 'Pitre Buick GMC', label: 'Pitre Buick GMC' },
        { value: 'Sunset Motors', label: 'Sunset Motors' },
        { value: 'Speedy Wheels', label: 'Speedy Wheels' },
        { value: 'Elite Autos', label: 'Elite Autos' },
        { value: 'Golden Motors', label: 'Golden Motors' },
        { value: 'Thunder Auto', label: 'Thunder Auto' },
        { value: 'Cityscape Cars', label: 'Cityscape Cars' },
        { value: 'Majestic Motors', label: 'Majestic Motors' },
        { value: 'Eagle Eye Autos', label: 'Eagle Eye Autos' },
        { value: 'Sprint Auto Solutions', label: 'Sprint Auto Solutions' },
        { value: 'Grand Prix Motors', label: 'Grand Prix Motors' },
        { value: 'Royal Wheels', label: 'Royal Wheels' },
        { value: 'Pinnacle Cars', label: 'Pinnacle Cars' },
        { value: 'Prime Drive', label: 'Prime Drive' },
        { value: 'Dynamic Motors', label: 'Dynamic Motors' },
        { value: 'Precision Auto', label: 'Precision Auto' },
        { value: 'Evergreen Vehicles', label: 'Evergreen Vehicles' },
        { value: 'Blue Ribbon Autos', label: 'Blue Ribbon Autos' },
        { value: 'Safari Motors', label: 'Safari Motors' },
        { value: 'Vanguard Auto', label: 'Vanguard Auto' },
        { value: 'Velocity Motors', label: 'Velocity Motors' },
        { value: 'Omega Cars', label: 'Omega Cars' },
        { value: 'Supreme Autos', label: 'Supreme Autos' },
        { value: 'Victory Vehicles', label: 'Victory Vehicles' },
        { value: 'Zenith Motors', label: 'Zenith Motors' }
    ]

    const [tableTitles, setTableTitles] = useState([
        {
            title: 'Quantity',
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>{props.data}</span>),
            default: 0,
        },
        {
            title: 'Report Type',
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>{props.data}</span>),
            default: '',
        },
        {
            title: 'Agent',
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>{props.data}</span>),
            default: '',
        },
        {
            title: 'Dealer',
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>{props.data}</span>),
            default: '',
        },
        {
            title: 'Admin',
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>{props.data}</span>),
            default: '',
        },
        {
            title: 'Contract Type',
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>{props.data}</span>),
            default: '',
        },
        {
            title: 'Contract Count',
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>{props.data}</span>),
            default: 0,
        },
        {
            title: 'Net',
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>${props.data}</span>),
            default: 0,
        },
        {
            title: 'Reason',
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>{props.data}</span>),
            default: '',
        },
        {
            title: 'Action',
            displayElement: (props) => (
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <IconButton onClick={() => approveReport(props.index, props.reportID)} Style={{backgroundColor: props.colors.primary, marginLeft: '10px'}} size={27} image={Approve} colors={props.colors}></IconButton>
                    <IconButton onClick={() => {setDenyReportModal(true); setDenyReportIndex(props.index)}} Style={{backgroundColor: props.colors.warning, marginLeft: '10px', marginRight: '10px'}} size={27} image={Deny} colors={props.colors}></IconButton>
                </div>),
            default: undefined,
        },
    ])

    const addRow = () => {
        console.log('Add Row!')
        setTableValues((tableValues) => tableValues.map((column, index) => [
            ...column,
            tableTitles[index].default
        ]))
        setRowSelected((rowSelected) => [...rowSelected, false]);
    }

    const templates = [
        {
            id: 0,
            name: "Template 1",
            dealer: '4 Season Motors',
            admin: 'Liberty Shield',
            contractType: 'VSC',
            grossPerContract: 200,
            value: 'Template 1',
            label: 'Template 1',
        },
        {
            id: 1,
            name: "Template 2",
            dealer: '4 Season Motors',
            admin: 'Liberty Shield',
            contractType: 'VSC',
            grossPerContract: 300,
            value: 'Template 2',
            label: 'Template 2',
        },
        {
            id: 2,
            name: "Template 3",
            dealer: '4 Season Motors',
            admin: 'Liberty Shield',
            contractType: 'VSC',
            grossPerContract: 400,
            value: 'Template 3',
            label: 'Template 3',
        },
        {
            id: 3,
            name: "Template 4",
            dealer: '4 Season Motors',
            admin: 'Liberty Shield',
            contractType: 'VSC',
            grossPerContract: 500,
            value: 'Template 4',
            label: 'Template 4',
        },
        {
            id: 4,
            name: "Template 5",
            dealer: '4 Season Motors',
            admin: 'Liberty Shield',
            contractType: 'VSC',
            grossPerContract: 2600,
            value: 'Template 5',
            label: 'Template 5',
        },
    ]

    const deleteRow = (index) => {
        console.log('Deleted Row')
        setTableValues((tableValues) => tableValues.map((column) => {
            return [...column.slice(0, index), ...column.slice(index + 1)];
        }))
        setRowSelected((rowSelected) => [...rowSelected.slice(0, index), ...rowSelected.slice(index + 1)])
    }

    const onTableChange = (e, y, x) => {
        //console.log('Table Updated')
        if (x === 1) //check what column the change was in, 1 in this case is the template column
        {
            templates.map((template) => {
                if (template.name === e)
                {
                    applyTemplate(template, y)
                }
            })
        }
        setTableValues((tableValues) => tableValues.map((column, indexParent) => {
            return column.map((data, index) => {
                if (index === y && indexParent === x)
                {
                    return e;
                }
                return data;
            })
        }))
    }

    const applyTemplate = (template, row) => {
        setTableValues((tableValues) => tableValues.map((column, indexX) => {
            if (indexX === 2) {column[row] = template.dealer}
            if (indexX === 3) {column[row] = template.admin}
            if (indexX === 4) {column[row] = template.contractType}
            if (indexX === 5) {column[row] = template.grossPerContract}
            return column;
        }))
    }

    const submitSelectedReports = () => {
        setSubmitReportModal(true)
    }

    const [rowSelected, setRowSelected] = useState([false])

    const [manageTemplateModal, setManageTemplateModal] = useState(false)
    const [manageSaveTemplateModal, setManageSaveTemplateModal] = useState(false)

    const [tableValues, setTableValues] = useState([
        [tableTitles[0].default], //Quantity
        [tableTitles[1].default], //Report Type
        [tableTitles[2].default], //Agent
        [tableTitles[3].default], //Dealer
        [tableTitles[4].default], //Contract Type
        [tableTitles[5].default], //Contract Count
        [tableTitles[6].default], //Net
        [tableTitles[7].default], //Edit Buttons (Empty as they don't need data)
        [tableTitles[8].default], //Edit Buttons (Empty as they don't need data)
        [tableTitles[9].default],
    ]) 

    const [tableData, setTableData] = useState([
        [tableTitles[0].default],
        [tableTitles[1].default],
        [tableTitles[2].default],
        [tableTitles[3].default],
        [tableTitles[4].default],
        [tableTitles[5].default],
        [tableTitles[6].default],
        [tableTitles[7].default],
        [tableTitles[8].default],
        [tableTitles[9].default],
    ])

    const [dropdownData, setDropdownData] = useState([
        [[]],
        [[]],
        [[]],
        [dealers2], //admin
        [dealers2], //contract type
        [[]],
        [[]],
        [[]],
        [[]],
        [[]],
    ])

    const showTableData = () => {
        console.log(tableValues)
    }

    const [submitReportModal, setSubmitReportModal] = useState(false)
    const [denyReportModal, setDenyReportModal] = useState(false)

    const [cookies, setCookies] = useCookies([])

    const [reportID, setReportID] = useState('hmm')

    useEffect(() => {

        console.log('useEffect: getting new Data')

        let tokenValues = 
        {
            refresh_token: cookies['refresh_token'],
            refresh_token_expires: cookies['refresh_token_expires'],
            access_token: cookies['access_token'],
            access_token_expires: cookies['access_token_expires'],
        }

        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");
    
        var requestOptions = {
          method: 'GET',
          headers: myHeaders,
          redirect: 'follow'
        };

        let tempTableValues = [
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
        ]
    
        props.tokenSafeAPIRequest('/report/adjustment/need_approval', requestOptions, tokenValues, (result) => {
            console.log(result)

            if (result.length === 0)
            {
                setTableValues(tempTableValues)
            }
            else
            {
                let tempReportID = []
                result.map((report, index) => {
                    tempTableValues[0].push(report.quantity)
                    tempTableValues[1].push(report.report_type)
                    tempTableValues[2].push(report.subagent_ID)
                    tempTableValues[3].push(report.dealership_ID)
                    tempTableValues[4].push(report.admin_ID)
                    tempTableValues[5].push(report.contract_type + " - " + report.contract_subtype)
                    tempTableValues[6].push(report.total_contract_count)
                    tempTableValues[7].push(report.net)
                    tempTableValues[8].push(report.reason)
                    tempTableValues[9].push(report.code)
                    tempReportID.push([report.id, report.code])
                })
    
                console.log(tempTableValues)
    
                setReportID(formatReportIDs(tempReportID))
    
                let newTempTableValues = (countDuplicateSubarrays(transposeArray(tempTableValues)))
                newTempTableValues.map((report, index) => {
                    report[0][0] = report[1]
                    report.pop()
                })
    
                let finalNewTempTableValues = transposeArray(transposeArray(newTempTableValues)[0])
                let tempData = {...finalNewTempTableValues} //needed to make copy otherwise it saves reference and then updates as finalNewTempTableValue changes from the rest of the function

                console.log(finalNewTempTableValues)
    
                var requestOptions2 = {
                    method: 'POST',
                    headers: myHeaders,
                    redirect: 'follow',
                    body: JSON.stringify(finalNewTempTableValues[3])
                };
    
                props.tokenSafeAPIRequest('/dealership/bulk?basic_info=true', requestOptions2, tokenValues, (result2, status1) => {
                    if (status1 === 200)
                    {
                        finalNewTempTableValues[3] = result2
                    }
                    var requestOptions3 = {
                        method: 'POST',
                        headers: myHeaders,
                        redirect: 'follow',
                        body: JSON.stringify(finalNewTempTableValues[2])
                    };
            
                    props.tokenSafeAPIRequest('/user/bulk?basic_info=true', requestOptions3, tokenValues, (result3, status2) => {
                        if (status2 === 200)
                        {
                            finalNewTempTableValues[2] = result3
                        }
                        var requestOptions3 = {
                            method: 'POST',
                            headers: myHeaders,
                            redirect: 'follow',
                            body: JSON.stringify(finalNewTempTableValues[4])
                        };

                        props.tokenSafeAPIRequest('/admin/bulk?basic_info=true', requestOptions3, tokenValues, (result4, status4) => {
                            if (status4 === 200)
                            {
                                finalNewTempTableValues[4] = result4
                            }
                            console.log(finalNewTempTableValues)
                            setTableValues(finalNewTempTableValues)
                            setRowSelected((rowSelected) => new Array(finalNewTempTableValues[0].length).fill('').map((report, index) => {
                                return [...rowSelected, false]
                            }))
                        })
                        //console.log(finalNewTempTableValues)
                    })
                })
            }
        })


    },[refresh])

    function formatReportIDs(originalArray) {
        const result = [];
      
        // Create a temporary object to store codes and their corresponding IDs
        const temp = {};
      
        originalArray.forEach(([id, code]) => {
          // If the code doesn't exist in the temp object, add it with an empty array
          if (!temp[code]) {
            temp[code] = [];
          }
      
          // Push the id to the corresponding code's array
          temp[code].push(id);
        });
      
        // Convert the temp object into the desired array format
        for (const [code, ids] of Object.entries(temp)) {
          result.push({ code, ids });
        }
      
        return result;
      }

    const transposeArray = (array) => {
        if (!Array.isArray(array) || array.length === 0 || !array.every(subArray => Array.isArray(subArray))) {
            return '';
        }
    
        // Check if the first element of the array is not empty
        if (array[0].length === 0) {
            return '';
        }
        return array[0].map((_, colIndex) => array.map(row => row[colIndex]));
    };

    const countDuplicateSubarrays = (arrayOfArrays) => {
        // Check if arrayOfArrays is an array
        if (!Array.isArray(arrayOfArrays)) {
            return '';
        }
    
        const arrayMap = new Map();
      
        arrayOfArrays.forEach(subArray => {
          // Convert each subarray to a string to use as a unique key for comparison
          const key = JSON.stringify(subArray);
          if (arrayMap.has(key)) {
            arrayMap.set(key, arrayMap.get(key) + 1);
          } else {
            arrayMap.set(key, 1);
          }
        });
      
        // Convert the map back into an array of arrays with quantities
        return Array.from(arrayMap, ([key, value]) => [JSON.parse(key), value]);
    };

    function getCurrentTimeFormatted() {
        const now = new Date();
  
        let hours = now.getHours();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        
        hours = hours % 12; // Convert to 12-hour format
        hours = hours ? hours : 12; // The hour '0' should be '12'
        
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const seconds = now.getSeconds().toString().padStart(2, '0');
      
        return `${hours.toString().padStart(2, '0')}:${minutes}:${seconds} ${ampm}`;
    }

    const [denyReportIndex, setDenyReportIndex] = useState(-1)

    const denyReport = (reason) => {
        let tokenValues = 
        {
            refresh_token: cookies['refresh_token'],
            refresh_token_expires: cookies['refresh_token_expires'],
            access_token: cookies['access_token'],
            access_token_expires: cookies['access_token_expires'],
        }

        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            'IDs': reportID[denyReportIndex].ids,
            'rejection_reason': reason,
        });

        console.log({
            'IDs': reportID[denyReportIndex].ids,
            'rejection_reason': reason,
        })

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          redirect: 'follow',
          body: raw
        };

        props.tokenSafeAPIRequest('/report/adjustment/reject', requestOptions, tokenValues, (result, status) => {
            if (status === 200)
            {
                setDenyReportModal(false)
                setNotification('Denied Report at: ' + getCurrentTimeFormatted())
                deleteRow(denyReportIndex)
                refreshData()
            } else {setNotification(props.getServerResponse(result))}
        })
    }

    const approveReport = (acceptedReportIndex, currentReportID) => {
        console.log(currentReportID)
        console.log(acceptedReportIndex)
        let tokenValues = 
        {
            refresh_token: cookies['refresh_token'],
            refresh_token_expires: cookies['refresh_token_expires'],
            access_token: cookies['access_token'],
            access_token_expires: cookies['access_token_expires'],
        }

        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify(
            currentReportID[acceptedReportIndex].ids,
        );

        console.log(
            currentReportID[acceptedReportIndex].ids,
        )

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          redirect: 'follow',
          body: raw
        };

        props.tokenSafeAPIRequest('/report/adjustment/approve', requestOptions, tokenValues, (result, status) => {
            if (status === 200)
            {
                setNotification('Approved Report at: ' + getCurrentTimeFormatted())
                deleteRow(acceptedReportIndex)
                refreshData()
            } else {setNotification(props.getServerResponse(result))}
        })
    }

    const [notification, setNotification] = useState('')

    return (
        <MainLayout buttonList={buttonList} headerData={headerData} colors={props.colors}>
            <Sidebar colors={props.colors} tab={0}></Sidebar>
            <Controller colors={props.colors} activeButton={false} buttonList={buttonList} title={"Adjustment Reports"} tokenSafeAPIRequest={props.tokenSafeAPIRequest}></Controller>
            <div>{/*Just to make sure nothing goes wrong with MainLayout, as this takes the place of MetricHeader*/}</div>
            <Table selectMenu={false} colors={props.colors} tableData={tableValues} tableInfo={tableTitles} reportID={reportID} dropdownData={dropdownData} rows={rowSelected} setRows={setRowSelected} onChange={onTableChange}></Table>
            <ModalManager colors={props.colors}>
                <ManageTemplate colors={props.colors} templates={templates} isOpen={manageTemplateModal} onChange={(value, y, x) => console.log(value, x, y)} setIsOpen={() => setManageTemplateModal(false)}></ManageTemplate>
                <SaveTemplate colors={props.colors} isOpen={manageSaveTemplateModal} onChange={(value, y, x) => console.log(value, x, y)} setIsOpen={() => setManageSaveTemplateModal(false)}></SaveTemplate>
                <SubmitReport colors={props.colors} isOpen={submitReportModal} setIsOpen={() => setSubmitReportModal(false)}></SubmitReport>
                <DenyReport colors={props.colors} isOpen={denyReportModal} setIsOpen={() => setDenyReportModal(false)} onClick={denyReport}></DenyReport>
            </ModalManager>
            <Notification colors={props.colors} message={notification}></Notification>
        </MainLayout>
    )
}

export default Main
